<template>
  <div v-show="sessionsSelected">
    <div class="ml-2">
      <ul class="nav nav-tabs" role="tablist">
      <li
        class="nav-item"
        v-for="(sensorType, index) in sensorTypes[deviceType]"
        :key="sensorType"
      >
        <a
          class="nav-link"
          :class="{ active: index === activeChartIndex }"
          @click="setActiveChartIndex(index)"
          data-toggle="tab"
          :href="'#' + sensorType"
        >
          {{ sensorType }}
        </a>
      </li>
    </ul>
    </div>
    <div class="sensor-charts mt-2 ml-2">
      <div v-for="title in data.keys()" :key="title" class="chart-container">
        <ComparisonLineChart
        v-show="shouldShowChartBy(title)"
        @chartsLoaded="chartsLoading = false"
        :id="title" :title="title" :sessionId="'V6wN2yl1A6mibJy0DoKp'" :series = data.get(title) :colors="chartColors.get(title)"></ComparisonLineChart>
      </div>
    </div>
    <Loading
      :active="chartsLoading"
      :is-full-page="true"
      color="var(--accent-color)"
      loader="bars"
      class="loader"
    />
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import processMultipleSessionData from './functions/processMultipleSessionsData'
import ComparisonLineChart from '../../../components/charts/ComparisonLineChart.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

export default {
  name: 'IntrasessionMultipleChart',
  props: [
    'deviceType',
    'sessionsSelected',
    'selectedUser',
    'sessions'
  ],
  components: {
    ComparisonLineChart,
    Loading
  },
  setup (props, { emit }) {
    const {
      data,
      shouldRenderCharts,
      clearSessionData,
      renderSensorDataByType,
      chartColors
    } = processMultipleSessionData()
    const activeChartIndex = ref(0)
    const chartsLoading = ref(false)
    const gloveSensorTypes = [
      'AngleX', 'AngleY', 'AngleZ', 'Pinky', 'Ring', 'Middle', 'Index', 'Thumb', 'Palm'
    ]
    const kneeSleeveSensorTypes = [
      'Angle', 'Hamstring', 'Calf', 'Quad', 'Shin'
    ]
    const testSensorTypes = Array.from({ length: 32 }, (_, i) => `P${i}`)
    const neatSensorTypes = ['P0', 'P8', 'P23', 'P31']
    const bandSensorTypes = ['Temperature0', 'Temperature1', 'Temperature2', 'Temperature3', 'Humidity0', 'Humidity1', 'Humidity2', 'Humidity3']

    const sensorTypes = {
      Glove: gloveSensorTypes,
      'Knee Sleeve': kneeSleeveSensorTypes,
      Pants: kneeSleeveSensorTypes,
      Test: testSensorTypes,
      Neat: neatSensorTypes,
      Band: bandSensorTypes
    }

    const setActiveChartIndex = (index) => {
      activeChartIndex.value = index
      getMultipleSessionsData()
    }

    const getMultipleSessionsData = async () => {
      chartsLoading.value = true
      renderSensorDataByType(props.sessions, props.selectedUser.devices, sensorTypes[props.deviceType][activeChartIndex.value], props.deviceType)
    }

    const shouldShowChartBy = (title) => {
      return title.includes(sensorTypes[props.deviceType][activeChartIndex.value].toLowerCase())
    }

    watch(() => props.sessions, async (newSessions) => {
      if (newSessions && newSessions.length > 0) {
        clearSessionData()
        await getMultipleSessionsData()
      }
    }, { immediate: true, deep: true })

    return {
      data,
      shouldRenderCharts,
      clearSessionData,
      renderSensorDataByType,
      activeChartIndex,
      setActiveChartIndex,
      getMultipleSessionsData,
      shouldShowChartBy,
      chartColors,
      chartsLoading,
      testSensorTypes,
      sensorTypes
    }
  }
}
</script>
